import { render, staticRenderFns } from "./ordersTb.vue?vue&type=template&id=3caad358&scoped=true"
import script from "./ordersTb.vue?vue&type=script&lang=js"
export * from "./ordersTb.vue?vue&type=script&lang=js"
import style0 from "./ordersTb.vue?vue&type=style&index=0&id=3caad358&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3caad358",
  null
  
)

export default component.exports